import { BehaviorSubject } from "rxjs"

export default class FotosClass {
    public Id: number
    public OrdenLocalId: number
    public FileName: string
    public LocalId: number
    public FotoData: string
    public SHA256: string
    public SubidaDesdeMovil: boolean
    public HasGPSMetadataObservable?: BehaviorSubject<boolean>
    public Categoria: string
}
